

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { CenposAccountAddOrUpdateViewModel } from '@/models/payment/cenposAccount';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';
import { PayrocAccountAddOrUpdateViewModel } from '@/models/payment/payrocAccount';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class AddPayrocAccountPage extends Base {
    public vm: PayrocAccountAddOrUpdateViewModel = new PayrocAccountAddOrUpdateViewModel();
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public disableSubmitButton: boolean = false;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public payrocEnvironment: string = "";
    public created(): void {
        this.setFields();
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.vm.storeId.toString(), tab: 'PayrocAccount' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitPayrocAccount();
        } else {
            console.log(methodName);
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$parent.$t('stores.btnBackToStoreTitle'),
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t('stores.btnBack'),
            click: 'backToStoreEdit',
            icon: 'fas fa-arrow-left',
        });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setFields();
        this.vm.storeId = Number(this.$route.params.storeId);
        this.getPayrocAccountDetails();
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'environment',
                required: true,
                type: 'v-alynk-select',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Environment',
                    items: [
                        'Production',
                        'Sandbox',
                    ],
                    loading: false,
                    rules: [
                        v => this.required('Environment', v)
                    ], events: {
                        onChange: (items, value) => {
                            this.payrocEnvironment = value;
                            this.getPayrocAccountDetails();
                        },
                    },
                },
            },
            {
                key: 'manualTerminalId',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Manual Payment Terminal Id',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Manual Payment Terminal Id', v)
                    ]
                },
            },
            {
                key: 'apiKey',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Api Key',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Api Key', v)
                    ]
                },
            },
            {
                key: 'uri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Uri', v)
                    ]
                },
            },
            {
                key: 'tokenUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Token Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Token Uri', v)
                    ]
                },
            },
            {
                key: 'sessionTokenUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Session Token Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Session Token Uri', v)
                    ]
                },
            },
            {
                key: 'hostedFieldVersion',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 80,
                    label: 'Hosted Field Version',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Version', v)
                    ]
                },
            },
            {
                key: 'hostedFieldIntegrity',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Hosted Field Integrity',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Integrity', v)
                    ]
                },
            },
            {
                key: 'hostedFieldCdnUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'Hosted Field Cdn Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Cdn Uri', v)
                    ]
                },
            },
            {
                key: 'cardHolderNameUpdateUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 100,
                    label: 'CardHolderName Update Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('CardHolderName Update Uri', v)
                    ]
                },
            }
        ];
    }

    public validatePayrocAccount(): Vue & { validate: () => boolean } {
        return this.$refs.payrocAccountForm as Vue & { validate: () => boolean };
    }

    public async submitPayrocAccount(): Promise<void> {
        if (this.validatePayrocAccount().validate()) {
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                await storeService.updatePayrocAccounts(
                    this.vm.storeId,
                    this.vm.account
                );
                this.showAlert(true, 'Payroc Account Successfully saved');
                this.$router.push({
                    name: 'admin.stores.edit',
                    params: {
                        tenantId: this.tenantId.toString(),
                        enterpriseId: this.enterpriseId.toString(),
                        storeId: this.vm.storeId.toString(),
                        tab: 'PayrocAccount'
                    },
                });
            } finally {
                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }

    public async getPayrocAccountDetails(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields);
            const response = await storeService.getPayrocAccountDetails(
                this.vm.storeId,
                this.payrocEnvironment
            );
            if (response) {
                this.vm.account = response;
            }
        } finally {
            this.payrocEnvironment = "";
            this.formlyHideSkeleton(this.formFields);
        }
    }
}
